import { ShipstationIntegrationApiClient } from '@fourthwall/services/dist/ShipstationIntegrationApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useShipStationConfigurationQuery = createQueryHook(
  ShipstationIntegrationApiClient.getShipstationConfiguration,
  {
    queryKey: ['shipStationConfiguration'],
  },
)
